export default `${process.env.API_URL}/auth/google`;
